export class BibExemplarModel {
 bibExemplarId? :number =  0;
 bibDocumentoId? :number =  0;
 gesEscolaId? :number =  0;
 bibVolumeId? :number =  0;
 identificacao? :string =  '';
 bibLocalizacaoId? :number =  0;
 codigoBarra? :string =  '';
 dataAquisicao? :Date;
 bibFormaAquisicaoId? :number =  0;
 podeEmprestar? :number =  1;
 baixado? :number =  0;
 bibExemparAnteriorId? :number =  0;
 bibMotivoBaixaId? :number =  0;
 dataBaixa? :Date;
 bibTombamentoId? :number =  0;
 observacao? :string =  '';
 titulo? :string = '';

}
